import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57151434"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "btn_container" }
const _hoisted_3 = ["value", "checked"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-2x fa-times-circle" })
], -1))
const _hoisted_5 = { class: "btn_container" }
const _hoisted_6 = ["value", "checked"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-dot-circle" })
], -1))
const _hoisted_8 = { class: "btn_container" }
const _hoisted_9 = ["value", "checked"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-check-circle" })
], -1))



// Define props with their specific types

export default /*#__PURE__*/_defineComponent({
  __name: 'TriStateToggle',
  props: {
    value: {}
  },
  emits: ['select'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const emitSelect = (val: string) => {
  emit('select', val);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        type: "radio",
        class: "no",
        name: "radio",
        value: _ctx.value,
        checked: _ctx.value === 'no',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emitSelect('no')))
      }, null, 8, _hoisted_3),
      _hoisted_4
    ]),
    _createElementVNode("label", _hoisted_5, [
      _createElementVNode("input", {
        type: "radio",
        class: "neutral",
        name: "radio",
        value: _ctx.value,
        checked: _ctx.value === 'neutral' || _ctx.value === 'unsure',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emitSelect('neutral')))
      }, null, 8, _hoisted_6),
      _hoisted_7
    ]),
    _createElementVNode("label", _hoisted_8, [
      _createElementVNode("input", {
        type: "radio",
        class: "yes",
        name: "radio",
        value: _ctx.value,
        checked: _ctx.value === 'yes',
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emitSelect('yes')))
      }, null, 8, _hoisted_9),
      _hoisted_10
    ])
  ]))
}
}

})